// src/modules/useAppSettings.js
import { useEffect, useState } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function useAppSettings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  // Fetch once
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const ref = doc(db, "app_settings", "display");
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setSettings(snap.data());
        }
      } catch (err) {
        console.error("Error loading app settings:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const updateSetting = async (field, value) => {
    try {
      const ref = doc(db, "app_settings", "display");
      await updateDoc(ref, { [field]: value });
      setSettings((prev) => ({ ...prev, [field]: value }));
    } catch (err) {
      console.error("Failed to update setting:", err);
    }
  };

  return { settings, loading, updateSetting };
}
